import {Box, CssBaseline, ThemeProvider} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import Marquee from "../components/marquee/marquee";
import {MenuContext} from "../contexts/menuContext";
import Header from "./header/header";
import Routes from "./routes";
import Sidebar from "./sidebar/sidebar";

import "./layout.css";

const authRoute = ["/", "/signup"];

const layoutMenu = [
  "/",
  "/signup",
  "/settings",
  "/settings/myaccount",
  "/settings/profile",
  "/settings/privacy-safety",
  "/settings/payouts",
  "/settings/referral-links",
  "/settings/promo-material",
  "/settings/notifications",
  "/settings/subscriptions",
  "/settings/billing",
  "/settings/premium-plans",
  "/settings/send-gift",
];

const Layout = () => {
  const {open, setOpen, theme, isSmall} = useContext(MenuContext);
  const location = useLocation();
  const [currentRoute, setCurrentRoute] = useState(location?.pathname ?? "/");
  const isSettings = currentRoute.includes("/settings");
  useEffect(() => {
    setCurrentRoute(location?.pathname);
  }, [location?.pathname]);

  const headerRender = () => layoutMenu.includes(currentRoute);
  const sidebarRender = () => authRoute.includes(currentRoute) || location?.pathname.includes("/settings");
  //console.log("currentRoute", currentRoute);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box className={`${headerRender() ? "heroSetting" : ""} heroMain`}>
          {headerRender() || isSmall ? "" : <Header />}
          <Box className={`heroDetail ${open ? "heroSettingDetail" : ""}`} display="flex">
            {sidebarRender() ? "" : <Sidebar />}
            {isSmall && open && !isSettings && (
              <div
                onClick={() => setOpen(false)}
                style={{
                  position: "fixed",
                  zIndex: 2,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.6)",
                }}
              />
            )}
            <Box
              className={`heroContent overflow-x-auto ${open ? "" : "openContent"} ${
                sidebarRender() ? "authContent" : ""
              }`}
              style={
                isSmall
                  ? {
                      position: "fixed",
                      left: open && !isSettings ? "250px" : "0px",
                      transition: "left 0.3s",
                    }
                  : {position: "relative"}
              }
            >
              {headerRender() ? "" : isSmall && !isSettings ? <Header /> : ""}
              {headerRender() ? "" : <Marquee />}
              {Routes().find((route) => route.path === currentRoute)?.component}
            </Box>
          </Box>
        </Box>
        <div className="backdrop" id="backDrop"></div>
      </ThemeProvider>
    </>
  );
};

export default Layout;
